import { showErrorNotification } from '../../../global/notifications';
import { triggerPlanUpdated } from '../event-handlers';

let _k_terminationConfirmation = null;
let _$terminationDatePicker = null;
let _$terminationButton = null;
let _$terminationConfirmation = null;
let _$terminatePlan = null;
let _$closeWindow = null;
let _selectedEmployee, _selectedPlan, _effectiveDate, _completionDate = null;
let _terminationDate = null;

export function initializeTerminationUi(effectiveDate, completionDate, selectedEmployee, selectedPlan) {
    _selectedEmployee = selectedEmployee;
    _selectedPlan = selectedPlan;
    _effectiveDate = effectiveDate;
    _completionDate = completionDate;

    initializeElementVariables()
        .then(() => {
            _$terminationDatePicker.kendoDatePicker({
                min: _effectiveDate, max: _completionDate, format: 'MM/dd/yyyy', change: function (event) {
                    _terminationDate = event.sender._value;
                    _$terminationButton.attr('disabled', _terminationDate == null);
                }
            });

            _$terminationButton.click((event) => {
                setTerminationWindowData();
                _k_terminationConfirmation.open();
            });

            _$terminationButton.attr('disabled', true);

            initializeConfirmationWindow();
            attachTerminationWindowEvents();
        });
}

function initializeElementVariables() {
    return new Promise(resolve => {
        _$terminationDatePicker = $('#termination-datepicker');
        _$terminationButton = $('#termination-button');
        _$terminationConfirmation = $('#termination-confirmation');
        _$terminatePlan = $('#terminate-plan-button');
        _$closeWindow = $('#cancel-termination-button');

        resolve();
    });

}

function initializeConfirmationWindow() {
    _k_terminationConfirmation = _$terminationConfirmation.kendoWindow({
        actions: ['Close'], title: 'Terminate Commission Plan?', visible: false, maxWidth: 1080, maxHeight: 800, modal: true, scrollable: true, draggable: true, position: {
            top: 100, left: 100
        }
    }).data('kendoWindow');

    _k_terminationConfirmation.center();
}

function setTerminationWindowData() {
    $('.plan-name-display').text(_selectedPlan.Name);
    $('.employee-name-display').text(_selectedEmployee.EmployeeName);
    if (_terminationDate === null) {
        showErrorNotification('Please select a termination data');
        throw new Error('Please select a termination data');
    }

    $('.termination-date-display').text(kendo.toString(_$terminationDatePicker.val(), 'MM/dd/yyyy'));
}

function attachTerminationWindowEvents() {
    _$terminatePlan.click(() => {
        terminatePlan()
            .then(() => _k_terminationConfirmation.close())
            .catch(() => {
                console.error('error caught');
            })
            .finally(() => {
                triggerPlanUpdated();
                _k_terminationConfirmation.close();
                _$terminatePlan.attr('disabled', false);
            });
    });

    _$closeWindow.on('click', () => {
        _k_terminationConfirmation.close();
    });
}

function terminatePlan() {
    return new Promise((resolve, reject) => {
        _$terminatePlan.attr('disabled', true);

        const planId = $('#commission-plan-builder-grid').data('plan-id');

        let data = {
            Id                 : planId,
            EffectiveDate      : _effectiveDate,
            CompletionDate     : _completionDate,
            PlanConfigurationId: _selectedPlan.Id,
            EmployeeNumber     : _selectedEmployee.EmployeeNumber,
            EmployeeName       : _selectedEmployee.EmployeeName,
            TerminationDate    : kendo.toString(_terminationDate, 'MM/dd/yyyy')
        };

        try {
            $.post('/Commissions/CommissionPlanAssignment/TerminatePlan', data, (response) => {
                if (response) {
                    _$terminationButton.remove();
                    _$terminationDatePicker.data('kendoDatePicker').enable(false);
                    resolve();
                } else {
                    reject();
                }
            });
        } catch (e) {
            reject(e);
        }
    });

}
